import { RoundingOption } from "definitions/exporter";

// Точная копия серверного roundPrice (export-api
// src/services/goodsExporter/utils/roundPrice.ts) — предпросмотр обязан давать
// тот же результат, что реальная выгрузка, иначе пользователь не верит цифрам.
// При изменении серверной логики синхронизировать здесь.
export function roundPrice(price: number, option: RoundingOption): number {
  if (!Number.isFinite(price) || price <= 0) return price;

  // Шаг клампится до (разряды − 1): запрошенный шаг крупнее самого числа
  // (например, шаг 1000 при цене 850) раздул бы цену — сервер вместо этого
  // округляет более мелким шагом. Разрядность берём по длине строки, а не
  // Math.log10 (log10(1000) может вернуть 2.9999… и сбить шаг на порядок).
  const maxZeros = String(Math.floor(price)).length - 1;
  const effectiveZeros = Math.min(
    Math.max(Math.trunc(option.zeros), 0),
    maxZeros,
  );
  const step = 10 ** effectiveZeros;

  const quotient = price / step;
  const roundedQuotient =
    option.direction === "ceil"
      ? Math.ceil(quotient)
      : option.direction === "floor"
        ? Math.floor(quotient)
        : Math.round(quotient);

  const rounded = roundedQuotient * step;

  // Положительную цену не зануляем (актуально лишь для floor на суб-рублёвых ценах).
  return rounded > 0 ? rounded : price;
}
